import React from 'react';

const Search = () => {
  return (
    <div className="search">
        
        <input 
        type="text"
        placeholder="¿Con qué trámite te podemos ayudar?"
        onKeyPress={({ key, target: { value } }) => {
            if(key === 'Enter'){
            window.location.href = "https://ruts.hidalgo.gob.mx/?text=" + value;
            }
        }}
        />
    </div>
  )
}

export default Search